import { render, staticRenderFns } from "./CompleteOrRemark.vue?vue&type=template&id=fd72a440&scoped=true"
import script from "./CompleteOrRemark.vue?vue&type=script&lang=js"
export * from "./CompleteOrRemark.vue?vue&type=script&lang=js"
import style0 from "./CompleteOrRemark.vue?vue&type=style&index=0&id=fd72a440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd72a440",
  null
  
)

export default component.exports